
/**
 * UVRENA Product Policy Accordion
 * Adds a scoped CSS class to selected policy blocks.
 * Does not modify Ella's accordion behavior.
 */

(() => {
  'use strict';

  const POLICY_TITLES = new Set([
    'Shipping & Delivery',
    'Returns & Refunds',
    'Warranty Coverage'
  ]);

  const POLICY_CLASS = 'uvrena-policy-accordion';

  function initializePolicyAccordions(root = document) {
    root.querySelectorAll('summary.details__header')
      .forEach(summary => {
        const title = summary.textContent
          .replace(/\s+/g, ' ')
          .trim();

        if (!POLICY_TITLES.has(title)) {
          return;
        }

        const wrapper = summary.closest('.block.spacing-style');

        if (wrapper) {
          wrapper.classList.add(POLICY_CLASS);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializePolicyAccordions(),
      { once: true }
    );
  } else {
    initializePolicyAccordions();
  }

  // Support Shopify theme editor section reloading.
  document.addEventListener('shopify:section:load', event => {
    initializePolicyAccordions(event.target);
  });
})();
